import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import bindModel from '../../../common/bindModel.js';

const $ = window.$;

export default class ModalConvertToNewUser extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false
        }

        this.submit = this.submit.bind(this);
    }

    submit(event) {
        if (event.key == 'Enter' || event.target.tagName == "BUTTON") {
            this.setState({
                loading: true
            });
            var json = {
                id: this.props.id
            }
    
            axios.post(global.config.apiDomain + '/rest/admin/convertToNewUser', JSON.stringify(json), {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                this.setState({
                    loading: false
                });
    
                if (res.data.status == "OK") {
                    $("#modalConvertToNewUser").modal("hide");
                    toast.success(res.data.message);
                } else {
                    toast.warning(res.data.message);
                }
            }).catch(error => {
                this.setState({
                    loading: false
                });
                toast.error("ERROR");
            });
        }
    }

    render() {
        const model = bindModel(this);
        const { id } = this.state;

        return (
            <div>
                <div className="modal fade" id="modalConvertToNewUser" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Chuyển đổi tài khoản này thành newUser</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {/* <div className="modal-body">
                                
                            </div> */}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ?
                                    (
                                        <button style={{ width: "120px" }} className="btn btn-red" type="button" disabled>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Xác nhận...
                                        </button>
                                    ) :
                                    (
                                        <button
                                            style={{ width: "120px" }}
                                            type="button"
                                            className="btn btn-red"
                                            onClick={this.submit}>Xác nhận</button>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}